export default {"src":"/_next/static/media/down-arrow.1c920c0d.svg","height":9,"width":16};